import {appFetch, AppFetchResponse} from "../utils/appFetch";

export const getFlowTypes = async (domain: string): Promise<AppFetchResponse> => {
    return appFetch({
        endpoint: 'flow-types',
        method: 'GET',
        headers: {
            "Content-Type": "application/json",
        },
        isEncrypted: false,
        domain,
    });
}